import * as similarItemsGroupsSearchApi from '@/redux/api/similarItemsGroups';
import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/account/user/user.selectors';
import { AppDispatch } from '@/redux/store';

import { getIsBot } from '../analytics';
import { getClientIpAddress } from '../browser';
import { getDeployment } from '../config';
import { LoadSimilarItemsGroupsFulfilledPayload, SimilarItemsGroupsApiRow } from './similarItemsGroups.types';

export const loadSimilarItemsGroups = createAsyncThunk<LoadSimilarItemsGroupsFulfilledPayload, number>(
    'la/ui/similarItemsGroups/load',
    async (itemId, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const ipAddress = getClientIpAddress(state);
        const isBot = getIsBot(state);

        const { payload: groupsPayload } = await similarItemsGroupsSearchApi.fetchSimilarItemsGroups({
            authToken,
            deployment,
            ipAddress,
            isBot,
            itemId,
        });

        const rows = groupsPayload as SimilarItemsGroupsApiRow[];
        const itemIdList = [...new Set(rows.flatMap((row) => row.items.map((i) => i.itemId)))];
        const totalRecords = itemIdList.length;

        return {
            actionTime: Date.now(),
            itemId,
            itemIdList,
            totalRecords,
        };
    }
);

export const fetchSimilarItemsGroups = (itemId: number) => (dispatch: AppDispatch) => {
    if (!itemId) {
        return Promise.resolve();
    }
    return dispatch(loadSimilarItemsGroups(itemId));
};
